import { sortArray } from '@nu-art/ts-common';
export const SearchSorter_SearchTerms = {
    key: 'searchTerms',
    sortFunction: (results) => {
        sortArray(results, result => result.filterResults[SearchSorter_SearchTerms.key].value.length);
        sortArray(results, result => result.filterResults[SearchSorter_SearchTerms.key].score);
    }
};
//# sourceMappingURL=SearchSorter_SearchTerms.js.map